// components/common/Toast.jsx
import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, manualClose = false }) => {
  const [isVisible, setIsVisible] = useState(true);
  
  useEffect(() => {
    if (!manualClose && message) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [message, manualClose, onClose]);
  
  if (!message || !isVisible) return null;
  
  const getIcon = () => {
    switch(type) {
      case 'success': return 'bi-check-circle-fill';
      case 'danger': return 'bi-exclamation-circle-fill';
      case 'warning': return 'bi-exclamation-triangle-fill';
      case 'info': return 'bi-info-circle-fill';
      default: return 'bi-info-circle-fill';
    }
  };
  
  const getBgClass = () => {
    switch(type) {
      case 'success': return 'bg-success';
      case 'danger': return 'bg-danger';
      case 'warning': return 'bg-warning text-dark';
      case 'info': return 'bg-info';
      default: return 'bg-secondary';
    }
  };
  
  return (
    <div 
      className={`toast-container position-fixed bottom-0 end-0 p-3`}
      style={{ zIndex: 9999 }}
    >
      <div 
        className={`toast show ${getBgClass()} text-white`}
        role="alert"
      >
        <div className="d-flex">
          <div className="toast-body d-flex align-items-center">
            <i className={`bi ${getIcon()} me-2 fs-5`}></i>
            <span>{message}</span>
          </div>
          <button 
            type="button" 
            className="btn-close me-2 m-auto" 
            onClick={() => {
              setIsVisible(false);
              if (onClose) onClose();
            }}
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>
  );
};

export default Toast;